
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NumericInput',
  props: {
    modelValue: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    showRequired: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    displayValue: {
      get: function(): string | number {
        return this.modelValue
      },
      set: function(modifiedValue: string | number): void {
        const newValueAsString = modifiedValue.toString()
        let newValueAsNumber = parseFloat(newValueAsString.replace(/[^\d.]/g, ''))
        if (isNaN(newValueAsNumber))
          newValueAsNumber = 0

        if (typeof(this.modelValue) === 'string')
          this.$emit('update:modelValue', newValueAsNumber.toString())
        else
          this.$emit('update:modelValue', newValueAsNumber)
      }
    }
  }
})
